import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgAddress = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M18.113 16.091a1 1 0 0 1 1.245-.67C21.616 16.098 23 17.08 23 18.5c0 1.735-2.297 2.97-5.708 3.576l-.563.093c-.19.029-.384.056-.58.081l-.599.07c-.303.033-.613.061-.928.085l-.636.041-.65.03-.33.01-.668.012h-.676l-.668-.012-.33-.01-.65-.03-.636-.041a30.043 30.043 0 0 1-.928-.084l-.598-.07a25.873 25.873 0 0 1-.293-.04l-.572-.087C3.423 21.537 1 20.282 1 18.5c0-1.42 1.384-2.402 3.642-3.08a1 1 0 1 1 .574 1.917c-.816.244-1.45.526-1.852.81-.138.1-.23.18-.286.24l-.06.074c-.013.019-.018.032-.018.039 0 .204.276.437.773.671l.266.117c.095.04.195.078.301.116l.335.115c.117.038.24.075.367.112l.397.109c.068.018.138.036.21.053l.439.103c.15.033.306.066.466.097l.49.091.515.085.266.04.546.072.565.063.584.054c.197.016.397.03.6.043l.614.032.627.02.318.005.321.002c.215 0 .428-.002.639-.007l.627-.02.615-.032c.202-.012.402-.027.6-.043l.583-.054.565-.063.546-.073.526-.08.254-.044.491-.091.236-.048.453-.1c.147-.034.289-.07.426-.105l.397-.109c.064-.018.126-.037.188-.056l.35-.113c.168-.057.323-.115.465-.174l.266-.117c.497-.234.773-.467.773-.671 0-.007-.005-.02-.018-.04l-.06-.073a1.935 1.935 0 0 0-.286-.239c-.402-.285-1.037-.567-1.852-.811a1 1 0 0 1-.67-1.246Z" />
      <path d="M12 1C7.863 1 4.5 4.281 4.5 8.34c0 2.465 1.337 4.855 3.532 7.118.746.77 1.542 1.47 2.338 2.09l.34.26.297.22.354.248.092.061a1 1 0 0 0 1.094 0l.315-.215.428-.313.34-.26a22.733 22.733 0 0 0 2.338-2.09c2.195-2.264 3.532-4.654 3.532-7.118C19.5 4.28 16.137 1 12 1Zm0 2c3.043 0 5.5 2.397 5.5 5.34 0 1.834-1.1 3.8-2.968 5.726a20.757 20.757 0 0 1-2.131 1.905l-.278.212-.123.091-.035-.024a20.757 20.757 0 0 1-2.497-2.184C7.6 12.14 6.5 10.174 6.5 8.341 6.5 5.397 8.957 3 12 3Z" />
      <path d="M12 5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgAddress)
const Memo = memo(ForwardRef)
export default Memo
